module.exports = __webpack_public_path__ + "static/media/kocka2IPADRAM.91a33162.png";